import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import Loader from "../generic/Loader";
import CardNoImage from "../../../assets/img/cardNoImage.png";
import IconButton from "../generic/IconButton";
import ButtonComponent from "../generic/ButtonComponent";

@inject("store")
@observer
class ListView extends Component {
  componentDidMount() {
    this.props.store.WindowSizeStore.setWindow();
  }

  renderQuantityAndBuyPriceInputs = (
    completed,
    quantity,
    setName,
    rarity,
    type,
    variant,
    isOverStock,
    currencySymbol,
    buyPrice,
    isPaidInCash,
    cardName,
    cardId,
    viewRef
  ) => {
    const { onVariantQuantityChange, onVariantBuyPriceChange } = this.props;
    return (
      <Fragment>
        <span className="buylist-item-input quantity-label">Qty</span>
        <span className="buylist-item-input">
          {completed ? (
            `${quantity} @ `
          ) : (
            <input
              aria-label={`${variant.name} quantity`}
              className="quantity"
              type="number"
              min={0}
              step={1}
              value={quantity}
              onChange={(event) => {
                onVariantQuantityChange(
                  cardName,
                  cardId,
                  setName,
                  type,
                  isOverStock,
                  variant.id,
                  event.target.value
                );
                viewRef.current = event.target;
              }}
              data-testid="quantity"
            />
          )}
        </span>
        &nbsp;
        <span className="buylist-item-input" style={{ whiteSpace: "pre" }}>
          {currencySymbol}
          {completed ? (
            buyPrice
          ) : (
            <input
              aria-label={`${variant.name} buy price`}
              className="buy-price"
              type="number"
              min={0}
              step={0.01}
              value={buyPrice}
              onChange={(event) => {
                onVariantBuyPriceChange(
                  cardName,
                  cardId,
                  setName,
                  type,
                  isOverStock,
                  variant.id,
                  isPaidInCash,
                  event.target.value
                );
                viewRef.current = event.target;
              }}
              data-testid="buy-price"
            />
          )}
        </span>
      </Fragment>
    );
  };

  render() {
    const { removeLine, setSearchModalVisible, viewRef } = this.props;
    const { BuylistRulesStore, CustomersStore, MainStore, WindowSizeStore } =
      this.props.store;
    const { completed, paymentType, cards } = BuylistRulesStore.buylistDetails;
    const isPaidInCash = paymentType === "Cash";
    const currencySymbol = MainStore.currency || "$";
    const { windowWidth } = WindowSizeStore;

    if (!CustomersStore.customerVariants) return <Loader />;

    return (
      <div className="col-md-12 buylistList">
        <div className="row">
          <table>
            <thead>
              <tr>
                <td></td>
                <td>Card</td>
                {windowWidth >
                CustomersStore.customerVariants.length * 150 + 1000 ? (
                  CustomersStore.customerVariants.map((variant, _index) => (
                    <td
                      key={_index}
                      style={{ textAlign: `${completed ? "" : "center"}` }}
                    >
                      {variant.name}
                    </td>
                  ))
                ) : (
                  <td>Variant Quantity and Buy Price</td>
                )}
                <td>Total Buy Price</td>
                <td>Total Sell Price</td>
                <td>Buy limit exceeded</td>
                {!completed && <td></td>}
              </tr>
            </thead>
            <tbody>
              {cards.map((card, index) => {
                const {
                  imageUrl,
                  cardName,
                  cardId,
                  type,
                  setName,
                  rarity,
                  variants,
                  isOverStock,
                } = card;
                return (
                  <tr
                    key={index}
                    style={{ lineHeight: "1.5em" }}
                    className={`list-view__card-row
                      ${
                        Object.values(variants).reduce(
                          (count, variant) => (count += variant.quantity),
                          0
                        ) === 0
                          ? "error"
                          : ""
                      }
                    `}
                  >
                    <td>
                      <img src={imageUrl} role="presentation" />
                    </td>
                    <td>
                      {cardName}
                      {type ? "- " + type : ""}
                      <br />
                      <em>{setName}</em>
                      {rarity ? (
                        <>
                          <br />
                          <span>{rarity}</span>
                        </>
                      ) : null}
                    </td>
                    {windowWidth >
                    CustomersStore.customerVariants.length * 150 + 1000 ? (
                      CustomersStore.customerVariants.map((variant, _index) => {
                        let quantity = 0;
                        let buyPrice = 0;
                        if (
                          Object.keys(variants).includes(String(variant.id))
                        ) {
                          const _variant = variants[variant.id];
                          quantity = _variant.quantity;
                          buyPrice = isPaidInCash
                            ? _variant.cashBuyPrice
                            : _variant.storeCreditBuyPrice;
                        }
                        return (
                          <td key={_index} style={{ whiteSpace: "pre" }}>
                            {this.renderQuantityAndBuyPriceInputs(
                              completed,
                              quantity,
                              setName,
                              rarity,
                              type,
                              variant,
                              isOverStock,
                              currencySymbol,
                              buyPrice,
                              isPaidInCash,
                              cardName,
                              cardId,
                              viewRef
                            )}
                          </td>
                        );
                      })
                    ) : (
                      <td>
                        <div className="vertialVariantPricing">
                          {CustomersStore.customerVariants.map(
                            (variant, _index) => {
                              let quantity = 0;
                              let buyPrice = 0;
                              if (
                                Object.keys(variants).includes(
                                  String(variant.id)
                                )
                              ) {
                                const _variant = variants[variant.id];
                                quantity = _variant.quantity;
                                buyPrice = isPaidInCash
                                  ? _variant.cashBuyPrice
                                  : _variant.storeCreditBuyPrice;
                              }
                              return (
                                <Fragment key={_index}>
                                  <span>{variant.name}&nbsp;</span>
                                  {this.renderQuantityAndBuyPriceInputs(
                                    completed,
                                    quantity,
                                    setName,
                                    rarity,
                                    type,
                                    variant,
                                    isOverStock,
                                    currencySymbol,
                                    buyPrice,
                                    isPaidInCash,
                                    cardName,
                                    cardId,
                                    viewRef
                                  )}
                                </Fragment>
                              );
                            }
                          )}
                        </div>
                      </td>
                    )}
                    <td>
                      {MainStore.currencyBuilder(
                        Object.values(card.variants).reduce(
                          (sum, variant) =>
                            sum +
                            parseFloat(variant.quantity) *
                              parseFloat(
                                isPaidInCash
                                  ? variant.cashBuyPrice
                                  : variant.storeCreditBuyPrice
                              ),
                          0
                        )
                      )}
                    </td>
                    <td>
                      {MainStore.currencyBuilder(
                        Object.values(card.variants).reduce((sum, variant) => {
                          return (
                            sum +
                            (variant.quantity > 0
                              ? parseFloat(variant.quantity) *
                                parseFloat(variant.storeSellPrice)
                              : 0)
                          );
                        }, 0)
                      ) || "N/A"}
                    </td>
                    <td>{isOverStock && <i class="fas fa-check"></i>}</td>
                    {!completed && (
                      <td>
                        <IconButton
                          aria-label="Remove line"
                          icon="far fa-trash-alt"
                          onClick={() => removeLine(index)}
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
              {!completed && (
                <tr>
                  <td>
                    <img src={CardNoImage} role="presentation" />
                  </td>
                  <td colSpan="6">
                    <ButtonComponent
                      compact
                      icon="fal fa-plus"
                      iconPosition="left"
                      onClick={(event) =>
                        setSearchModalVisible(true, event.currentTarget)
                      }
                    >
                      Add a Card
                    </ButtonComponent>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

ListView.propTypes = {
  onVariantQuantityChange: PropTypes.func.isRequired,
  onVariantBuyPriceChange: PropTypes.func.isRequired,
  removeLine: PropTypes.func.isRequired,
  setSearchModalVisible: PropTypes.func.isRequired,
};

export default ListView;
